export const fullscreenMainHeaderHeight = '70px';
